// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { EntityProposalFragment } from '../../../pages/proposal/graphql/EntityProposalFragment.generated';
import { GiftProposalFragment } from '../../../pages/proposal/graphql/GiftProposalFragment.generated';
import { CharitableProposalFragment_CltProposalFragment, CharitableProposalFragment_CrtProposalFragment } from '../../../pages/proposal/graphql/CharitableProposalFragment.generated';
import { gql } from '@apollo/client';
import { EntityProposalFragmentDoc } from '../../../pages/proposal/graphql/EntityProposalFragment.generated';
import { GiftProposalFragmentDoc } from '../../../pages/proposal/graphql/GiftProposalFragment.generated';
import { CharitableProposalFragment_CltProposalFragmentDoc, CharitableProposalFragment_CrtProposalFragmentDoc } from '../../../pages/proposal/graphql/CharitableProposalFragment.generated';
export type ProposalFragment = { __typename?: 'Proposal', id: string, displayName: string, createdAt: Time, updatedAt: Time, clientNotes: string, includeCumulativeView: boolean, entityProposals?: Array<(
    { __typename?: 'EntityProposal' }
    & EntityProposalFragment
  )> | null, giftingProposal?: (
    { __typename?: 'GiftingProposal' }
    & GiftProposalFragment
  ) | null, cltProposal?: (
    { __typename?: 'CLTProposal' }
    & CharitableProposalFragment_CltProposalFragment
  ) | null, crtProposal?: (
    { __typename?: 'CRTProposal' }
    & CharitableProposalFragment_CrtProposalFragment
  ) | null, household: { __typename?: 'Household', id: string, subBrand?: { __typename?: 'SubBrand', id: string } | null } };

export const Operations = {
  Fragment: {
    Proposal: 'Proposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ProposalFragmentDoc = gql`
    fragment Proposal on Proposal {
  id
  displayName
  createdAt
  updatedAt
  clientNotes
  includeCumulativeView
  entityProposals {
    ...EntityProposal
  }
  giftingProposal {
    ...GiftProposal
  }
  cltProposal {
    ...CharitableProposalFragment_CLTProposal
  }
  crtProposal {
    ...CharitableProposalFragment_CRTProposal
  }
  household {
    id
    subBrand {
      id
    }
  }
}
    ${EntityProposalFragmentDoc}
${GiftProposalFragmentDoc}
${CharitableProposalFragment_CltProposalFragmentDoc}
${CharitableProposalFragment_CrtProposalFragmentDoc}`;